import { useSelector } from 'react-redux';

export const TIER_ORDER = ['stage0', 'stage1', 'stage2'];

export const TIER_LABELS = {
    stage0: 'Stage 0 · Free Entry',
    stage1: 'Stage 1 · Clinical Workflow',
    stage2: 'Stage 2 · Full Platform',
};

export const selectEntitlements = (state) => (state && state.auth && state.auth.entitlements) || null;

// Features resolve as allowed until entitlements load (backend enforces authoritatively).
export const useFeature = (featureKey) => {
    const entitlements = useSelector(selectEntitlements);
    if (!featureKey) return true;
    if (!entitlements || !entitlements.features) return true;
    if (!(featureKey in entitlements.features)) return true;
    return !!entitlements.features[featureKey];
};

export const useClinicTier = () => {
    const entitlements = useSelector(selectEntitlements);
    return (entitlements && entitlements.clinic_tier) || 'stage0';
};

export const useSeatTier = () => {
    const entitlements = useSelector(selectEntitlements);
    return (entitlements && entitlements.seat_tier) || 'stage0';
};

export const useRequiredTier = (featureKey) => {
    const entitlements = useSelector(selectEntitlements);
    const map = entitlements && entitlements.feature_min_tier;
    return (map && map[featureKey]) || null;
};
